import React from "react";

export default function DfRadPayConfirm() {
  return <div>DfRadPayConfirm</div>;
}
